import React from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import colors from '../../styles/colors';
import Loader from '../Loader';
import { GET_SMS_TEMPLATES } from '../../graphql/queries';
import NoContent from '../../shared/NoContent';

const Container = styled.ul`
  width: 30vw;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: 0 10px;
  list-style: none;
  overflow: auto;
  position: relative;

  @media screen and (max-width: 991px) {
    width: 50vw;
  }

  @media screen and (max-width: 450px) {
    width: 80vw;
    max-height: 70vh;
  }
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
`;

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
`;

const ListContainer = styled.ul`
  flex-direction: column;
  overflow-y: auto;
  overflow-x: none;
  margin: 15px 0px;
  list-style-type: none;
  border-radius: 7px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  position: relative;
  padding: 0px 20px;
  max-width: 500px;

  @media screen and (max-width: 991px) {
    width: calc(80vw - 15px);
    padding: 0px;
  }
`;

const ListItem = styled.li`
  cursor: pointer;
  border: 1px solid ${colors.grey5};
  font-size: 15px !important;
  padding: 15px 5px;
  color: #333333;
  width: 100%;
  list-style-type: none;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
  font-size: 17px;
  &:hover {
    background-color: rgb(39, 187, 173);
  }
`;

const TemplateListModal = ({ setValues, close }) => {
  const { data, loading } = useQuery(GET_SMS_TEMPLATES);

  const listItemClick = (templateData) => {
    setValues((oldValues) => ({ ...oldValues, text: templateData.text }));
    close();
  };

  return (
    <Container>
      {!loading && data?.templates.length > 0 ? (
        <ListContainer>
          {data?.templates.map((item, i) => (
            <ListItem key={i} onClick={() => listItemClick(item)}>
              {item.text}
            </ListItem>
          ))}
        </ListContainer>
      ) : (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      )}
      {!loading && data?.templates.length === 0 && (
        <ListContainer>
          <NoContent header="No Tempaltes Available" />
        </ListContainer>
      )}
    </Container>
  );
};

export default TemplateListModal;
